function NotFound(): React.JSX.Element {
    return (
        <div>
            Not Found
        </div>
    );
}

export default NotFound;